<template>
    <!-- Sliding div -->
    <div class="sidebar-help">
        <div class="sidebar-help">
            <iframe :src="$tera.project.TrialWizard.googleDocBaseURLForHelp" frameborder="0" class="gdoc"></iframe>
            <button @click="closeHelp" class="closeButton animated-close">X</button>
        </div>
    </div>
</template>

<script>
import HelpMixin from "../mixins/HelpMixin";

export default {
    name: "HelpFrame",
    props: {
        googleDocUrl: String
    },
    mixins: [HelpMixin],
    components: {
    },
    data() {
        return {
            isHelpVisible: false,
        };
    },
    methods: {
        closeHelp() {
            this.$emit("close", false);
        }

    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* Sliding div */
.slidingDiv {
    position: fixed;
    right: 7px;
    top: 0;
    width: 585px;
    /* height: 100%; */
    height: 99vh;
    background-color: #fff;
    box-shadow: -2px 0px 10px rgba(0, 0, 0, 0.5);
    transform: translateX(100%);
    /* transition: transform 0.3s ease-in-out;
    z-index: 1000; */
    /* opacity: 0;  */
    transition: transform 2s ease-in-out, opacity 1s ease-in-out;
    z-index: 1000;
    overflow: hidden;
    margin-right: 30%;
    border: 8px solid #4e6596;
}

.slidingDiv.active {
    transform: translateX(0);
    opacity: 1;
}

/* Google Doc iframe */
.googleDocIframe {
    width: 120%;
    height: 100%;
    padding-right: 95px;
    padding-left: 0px;
    margin-left: 0px;
    border: none;
}

.sidebar-help {
    position: fixed;
    top: 0px;
    bottom: 0px;
    right: 0px;
    width: 500px;

    padding: 0px;
    transition: right 0.3s ease;
    background: radial-gradient(circle, #445886 0, #5c7cc0 100%);
    user-select: none;
    box-shadow: -5px 0 5px #00000055;
    z-index: 1;
    /* Preserve box-shadow above iFrame within <external/> */

    /* Google-Docs style overrides {{{ */
    & .gdoc {
        width: -webkit-fill-available;
        height: -webkit-fill-available;
        /* padding: 2px 8px !important; */
        &>.doc-content {
            padding: 2px 8px !important;
        }

        /* Special cases for images that are too large for the sidebar */
        & img.zoomable {
            max-width: calc(400px - 35px);
            aspect-ratio: 1/1 !important;
            height: auto !important;
            border: 0px solid transparent;
            border-radius: 5px;
            transition: all 0.2s ease-out;
            box-sizing: border-box;
            cursor: pointer;

            &:hover {
                border: 6px solid var(--accent);
                opacity: 0.6;
            }
        }
    }
}

/* Close button */
.closeButton {
    position: absolute;
    top: 10px;
    left: 3px;
    background-color: #f44336;
    color: white;
    border: none;
    border-radius: 30%;
    width: 30px;
    height: 30px;
    cursor: pointer;
}

.animated-close {
    position: absolute;
    /* display: inline-block; */
    /* padding: 7px 20px 4px 12px; */
    padding: 7px 20px 28px 10px;
    border: 2px solid transparent;
    background: linear-gradient(#d94949, #d56e6e) padding-box,
        linear-gradient(to right, #bb2c2c 25%, transparent 25%, transparent 50%, #e35c5b 50%, #e7c3b8 75%, transparent 75%) border-box;
    background-size: 200% 200%;
    background-position: 100% 100%;
    animation: moveBorder 4s linear infinite;
    transition: background 0.3s;
    border-radius: 5px;
    /* Optional: Adds rounded corners */
}

@keyframes moveBorder {
    0% {
        background-position: 0% 0%;
    }

    100% {
        background-position: 100% 100%;
    }
}

.animated-close:hover {
    background-size: 300% 300%;
    /* Makes the animation more noticeable on hover */
}
</style>
